<template>
  <div style="position: relative">
    <div class="uploadbtn" ref="uploadbtnRef">
      <i class="iconfont icon-upload_filled"></i>上传文件
    </div>
    <el-popover
      popper-class="file-upload-popover"
      placement="bottom-start"
      width="400"
      trigger="click"
    >
      <div class="uploader-list">
        <ul v-show="fileList.length > 0">
          <li v-for="(file, index) in fileList" :key="index">
            <FileItem :key="index" :file="file" />
          </li>
        </ul>
        <div class="emptycss" v-show="fileList.length === 0">
          <div style="text-align: center">
            <i
              class="iconfont icon-document-remove"
              style="font-size: 100px; color: #efefef"
            ></i>
            <div style="font-size: 14px; color: #5e5e5e">暂无上传任务</div>
          </div>
        </div>
      </div>
      <template #reference>
        <div class="uploadstatebtn">
          <el-badge is-dot :hidden="showbadge" class="item">
            <i class="iconfont icon-sort"></i>
          </el-badge>
        </div>
      </template>
    </el-popover>
  </div>
</template>

<script setup>
import { apiResourceNotify, apiResourceUrl } from "@/Api/AppApi";
import {
  defineProps,
  defineExpose,
  defineEmits,
  ref,
  computed,
  onMounted,
  reactive,
} from "vue";
import FileItem from "./FileItem.vue";
import TcUploader from "./TcUpload/tcuploader";

const props = defineProps(["projectId"]);
defineExpose({ bindDrap, unBindUploadDrop });
const emit = defineEmits(["dragenter", "dragleave", "addfilecomplete"]);

const fileList = reactive([]);
const showbadge = computed(
  () =>
    !fileList.some(
      (file) =>
        file.state === "uploading" ||
        file.state === "chunking" ||
        file.state === "computemd5" ||
        file.state === "verifyUpload"
    )
);

let uploader = null;
const uploadbtnRef = ref(null);
onMounted(() => {
  uploader = new TcUploader();
  uploader.on("fileAdded", fileAdded);
  uploader.on("fileNnotify", fileNnotify);
  uploader.on("fileRemove", fileRemove);
  uploader.on("fileverifyupload", fileverifyupload);
  uploader.on("dragenter", dragenter);
  uploader.on("dragleave", dragleave);
  uploader.on("drop", drap);
  uploader.bindUploadBtn(uploadbtnRef.value);
});

function bindDrap(doc) {
  uploader.bindUploadDrop(doc);
}
function unBindUploadDrop(doc) {
  uploader.unBindUploadDrop(doc);
}

async function fileAdded(tcfile) {
  fileList.push(tcfile);
  return true;
}
async function fileNnotify(tcfile) {
  console.log("上传完成", tcfile);
  const postData = {
    md5: tcfile.md5,
    project_id: props.projectId,
    file_name: tcfile.file.name,
    size: tcfile.file.size,
  };
  tcfile.state = "notify";
  const res = await apiResourceNotify(postData);
  if (res.code === 0) {
    tcfile.state = "complete";
    emit("addfilecomplete");
    console.log("合并成功", tcfile);
  } else {
    tcfile.state = "notifyfail";
    console.log("合并失败", tcfile);
  }
}
function fileRemove(file) {
  for (let i = 0; i < fileList.length; i++) {
    const item = fileList[i];
    if (item.md5 === file.md5) {
      fileList.splice(i, 1);
      uploader.removeFile(file);
      break;
    }
  }
}
async function fileverifyupload(tcfile) {
  tcfile.state = "verifyUpload";
  const res = await verifyUpload(tcfile);
  if (res.code === 0) {
    const chunkUrlList = res.data;
    let allSuccess = true;
    let complete = false;
    if (chunkUrlList !== null && chunkUrlList.length > 0) {
      for (let i = 0; i < chunkUrlList.length; i++) {
        const item = chunkUrlList[i];
        tcfile.chunks[item.num - 1].chunk.url = item.addr;
        if (item.addr !== "success") {
          allSuccess = false;
        } else {
          tcfile.chunks[item.num - 1].chunk.uploadProgress = 100;
          tcfile.chunks[item.num - 1].chunk.state = "complete";
        }
      }
    } else if (chunkUrlList == null || chunkUrlList.length == 0) {
      complete = true;
      for (let i = 0; i < tcfile.chunks.length; i++) {
        const item = tcfile.chunks[i];
        item.chunk.uploadProgress = 100;
        item.chunk.state = "complete";
      }
    }

    if (complete) {
      tcfile.state = "flashcomplete";
      tcfile.prevProgress = 1;
      tcfile.isCompleted("flashcomplete");
      emit("addfilecomplete");
    } else if (complete != true && allSuccess === true) {
      fileNnotify(tcfile);
    } else {
      tcfile.resume();
    }
  } else {
    tcfile.state = "error";
    tcfile.prevProgress = 0;
  }
}
function dragenter(evt) {
  emit("dragenter", evt);
}
function dragleave(evt) {
  if (checkDome(document.getElementById("uploadfileview"), evt.target)) {
    console.log("内部dom不触发", evt);
  } else {
    emit("dragleave", evt);
  }
}
function drap(evt) {
  emit("dragleave", evt);
}
function checkDome(parent, node) {
  const contains = document.documentElement.contains;
  if (contains != undefined && contains != null) {
    return parent !== node && parent.contains(node);
  } else {
    while (node && (node = node.parentNode)) if (node === parent) return true;
    return false;
  }
}

async function verifyUpload(tcfile) {
  const postData = {
    md5: tcfile.md5,
    project_id: props.projectId,
    file_name: tcfile.file.name,
    chunk_num: tcfile.chunks.length,
    chunk_size: "5M",
    size: tcfile.file.size,
  };
  const res = await apiResourceUrl(postData);
  return res;
}
</script>

<style lang="scss" scoped>
.uploadbtn {
  display: inline-block;
  height: 60px;
  border-right: 1px solid #e5e5e5;
  line-height: 60px;
  width: 190px;
  text-align: center;
  background: #3fbbff;
  color: #ffffff;
  font-size: 14px;
  cursor: pointer;
  &:hover {
    background: rgba(63, 187, 255, 0.89);
    color: #ffffff;
  }
}

.uploadstatebtn {
  position: absolute;
  height: 60px;
  top: 0;
  line-height: 60px;
  width: 59px;
  text-align: center;
  color: #a1a1a1;
  font-size: 22px;
  cursor: pointer;
  right: 0;
  margin-left: -5px;
  &:hover {
    color: #3fbbff;
  }
}

.uploader-list {
  position: relative;
  height: 300px;
}
.uploader-list > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.emptycss {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item /deep/ sup {
  margin-top: 18px;
  margin-right: 5px;
}
</style>
<style>
.file-upload-popover {
  overflow: auto;
  margin: 0;
}
</style>
